import * as React from "react";

export type LightBoxProps = { visible: boolean; imgLightBoxUrl?: string };

export default class LightBox extends React.Component<LightBoxProps> {
  render(): JSX.Element | null {
    if (!this.props.visible) {
      return null;
    }

    return (
      <div className="backdrop">
        <div>
          <img src={this.props.imgLightBoxUrl} className="light-box-pic" />
        </div>
      </div>
    );
  }
}
